<div class="container-fluid p-0">
  <div class="row">
    <div class="col-xl-5 p-0 d-flex align-items-center login-bg">
      <div class="d-flex p-xl-5 p-sm-3 m-auto flex-column w-100 justify-content-center align-items-center">
        <img class="w-100" src="/assets/images/logo/Dashboardly-logo-white.svg" alt="Dashboardly-logo" />
        <h6 class="text-center opacity-75 text-light my-4 w-75 text-secondary">
          {{ 'login.tagline' | transloco }}
        </h6>
      </div>
    </div>
    <div class="col-xl-7 p-0">
      <div class="login-card full-height">
        <div class="error-card col-xl-7 col-sm-10">
          <div class="error-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="64" height="64">
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z"
                fill="currentColor"
              />
            </svg>
          </div>
          <h2 class="error-title">{{ 'invalidLink.title' | transloco }}</h2>
          <p class="error-message mb-0">{{ 'invalidLink.hint' | transloco }}</p>
          <p class="error-message">
            {{ 'invalidLink.askOwner' | transloco }}
          </p>
          <div class="mt-4">
            <a href="/login" class="btn btn-outline-primary">{{ 'invalidLink.alreadyHaveAccount' | transloco }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
